import { useMemo } from "react";

import { normal } from "color-blend";

import { useTheme } from "../../../context/theme";
import { FOREGROUND_VARIANT_TO_OVERLAY_OPACITY_MAP } from "../consts";
import { ForegroundVariant } from "../types";
import {
  baseColorHexToRGBA,
  overlayColorHexToRGBA,
  RGBAToString
} from "../utils";

export default function useForegroundVariantColor(
  variant: ForegroundVariant
): string {
  const theme = useTheme();

  const foregroundVariantColor = useMemo(() => {
    const baseColorRGBA = baseColorHexToRGBA(theme.foreground);

    const overlayColorRGBA = overlayColorHexToRGBA(
      theme["foreground-variant-overlay"],
      FOREGROUND_VARIANT_TO_OVERLAY_OPACITY_MAP[variant]
    );

    const blendRGBA = normal(baseColorRGBA, overlayColorRGBA);

    return RGBAToString(blendRGBA);
  }, [theme, variant]);

  return foregroundVariantColor;
}
